import { Link } from "react-router-dom";
import { formatTemplateTotal } from "@school-sales-ai/shared";
import { useBroadcasts } from "@/hooks/useBroadcasts";
import { BroadcastStatusBadge } from "@/components/broadcasts/BroadcastStatusBadge";

function formatDate(iso: string): string {
  return new Date(iso).toLocaleString("es-MX", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function EnviosMasivos(): React.JSX.Element {
  const { data, isPending, isError, error } = useBroadcasts();

  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold text-ink-900">Envíos masivos</h1>
      <p className="mt-1 max-w-2xl text-sm text-ink-700">
        Cada envío de una plantilla de WhatsApp a los prospectos que coincidían con
        los filtros del Pipeline, con lo que pasó destinatario por destinatario.
      </p>

      {isPending ? (
        <p className="mt-6 text-sm text-ink-500">Cargando…</p>
      ) : isError ? (
        <p className="mt-6 text-sm text-red-600">{error.message}</p>
      ) : data.items.length === 0 ? (
        <div className="mt-6 rounded-lg border border-ink-100 bg-white p-8 text-center">
          <p className="text-sm text-ink-700">Aún no hay envíos masivos.</p>
          <p className="mt-1 text-sm text-ink-500">
            Si administración lo autoriza. Se lanzan desde{" "}
            <Link to="/pipeline" className="text-moss underline">
              Prospectos
            </Link>
            , con el botón «Enviar mensaje» junto a los filtros.
          </p>
        </div>
      ) : (
        <div className="mt-6 overflow-x-auto rounded-lg border border-ink-100 bg-white">
          <table className="w-full min-w-[760px] text-sm">
            <thead className="border-b border-ink-100 text-left text-xs uppercase tracking-wide text-ink-500">
              <tr>
                <th className="px-4 py-3 font-semibold">Fecha</th>
                <th className="px-4 py-3 font-semibold">Plantilla</th>
                <th className="px-4 py-3 font-semibold">Destinatarios</th>
                <th className="px-4 py-3 font-semibold">Resultado</th>
                <th className="px-4 py-3 font-semibold">Costo estimado</th>
                <th className="px-4 py-3 font-semibold">Estado</th>
                <th className="px-4 py-3 font-semibold">Lanzado por</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((b) => (
                <tr key={b.id} className="border-b border-ink-050 last:border-0">
                  <td className="px-4 py-3 text-ink-700">{formatDate(b.createdAt)}</td>
                  <td className="px-4 py-3">
                    <Link
                      to={`/envios/${b.id}`}
                      className="font-medium text-ink-900 underline decoration-ink-100 underline-offset-2"
                    >
                      {b.templateName}
                    </Link>
                  </td>
                  <td className="px-4 py-3 text-ink-700">
                    {b.recipientCount}
                    {b.excludedCount > 0 ? (
                      <span className="text-ink-500"> · {b.excludedCount} fuera</span>
                    ) : null}
                  </td>
                  <td className="px-4 py-3 text-ink-700">
                    {b.sentCount} enviados
                    {b.failedCount > 0 ? (
                      <span className="text-red-600"> · {b.failedCount} fallidos</span>
                    ) : null}
                  </td>
                  <td className="px-4 py-3 text-ink-700">
                    {formatTemplateTotal(Number(b.estimatedCost), b.currency)}
                  </td>
                  <td className="px-4 py-3">
                    <BroadcastStatusBadge status={b.status} />
                  </td>
                  <td className="px-4 py-3 text-ink-700">{b.createdByName}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
